import { 
   arrayOf,
   boolean,
   shape,
   string,
   number,
   any,
   oneOfType,
   oneOf,
   objectOf
} from 'prop-types';
import { CORE_CAP, FOIL, CORE, PREPREG, COPPER } from '../constants/globals';
import Core from '../components/common/materials/Core';
import Copper from '../components/common/materials/Copper';
import Prepreg from '../components/common/materials/Prepreg';

const construction = {
  glassType: string,
  layers: number,
  glassThickness: number
};

const dkdf = {
  label: string,
  mhz: number,
  value: number,
};

export const materialPropType = {
  id: string,
  construction: arrayOf(shape(construction)),
  dk: arrayOf(shape(dkdf)),
  df: arrayOf(shape(dkdf)),
  manufacturer: string,
  manufacturerId: number,
  product: string,
  resinContent: number,
  resinId: string,
  thickness: number,
  version: number
};

export const selectOptionPropType = {
  label: string,
  value: any
};

export const copperSpecPropType = {
  weight: number
};

export const materialWithCountPropType = {
    count: number,
    material: shape(materialPropType)
}

export const startNewFormValuesPropType = {
  innerCopperWeight: number,
  numberOfCopperLayers: number,
  outerCopperWeight: number,
  partNumber: string,
  projectName: string,
  resin: shape({
    manufacturerId: oneOfType([number, string]),
    id: oneOfType([number, string])
  }),
  stackupType: oneOf([CORE_CAP, FOIL])
}

const formConfigPropType = {
  initValue: any,
  validations: oneOfType([arrayOf(string), objectOf(arrayOf(string))])
}

export const startNewFormConfigPropType = {
  innerCopperWeight: shape(formConfigPropType),
  numberOfCopperLayers: shape(formConfigPropType),
  outerCopperWeight: shape(formConfigPropType),
  partNumber: shape(formConfigPropType),
  projectName: shape(formConfigPropType),
  resin: shape(formConfigPropType),
  stackupType: shape(formConfigPropType),
}

export const resinPropType = {
  id: oneOfType([number, string]),
  product: string,
  description: string,
  manufacturer: string,
  manufacturerId: oneOfType([number, string]),
  cores: arrayOf(shape(materialPropType)),
  prepregs: arrayOf(shape(materialPropType))
}

export const stackupLayerPropType = {
  id: string,
  key: string,
  index: number,
  positionY: number,
  type: oneOf([CORE, PREPREG, COPPER]),
  typeIndex: number,
  view: oneOf([Core, Prepreg, Copper].map(x => x.displayName)),
  _material: oneOfType([
    shape(materialPropType),
    arrayOf(shape(materialWithCountPropType))
  ])
}

export const stackupPropType = {
  name: string,
  partNumber: string,
  type: oneOf([CORE_CAP, FOIL, '']),
  newStackupSpec: shape(startNewFormValuesPropType),
  layers: arrayOf(shape(stackupLayerPropType))
}

export const calculationsShape = {
  isCalculating: boolean,
  errorMessages: arrayOf(string),
  calculated: shape({
    thickness: number,
    pressedThickness: number,
    impedanceModelings: arrayOf(shape({
      copperId: oneOfType([string, number]),
      copperKey: string,
      name: string,
      simulationModel: string,
      thickness: number,
      transmissionWidth: number,
      transmissionSpacing: number,
      impedances: arrayOf(shape({
        frequency: string,
        mhz: number,
        characteristicImpedance: number,
        differentialImpedance: number,  
        propagationDelay: number,
        params: shape({
          thickness: number,
          transmissionWidth: number,
          transmissionSpacing: number,
          dielectricUpHeight: number,
          dielectricDownHeight: number,
          dk: number
        })
      }))
    }))
  }),
  availableMhzs: arrayOf(number),
  displayMhz: number, 
}

export const unitShape = {
  name: string,
  symbol: string,
  siUnit: number,
  decimals: number, 
}

export const cameraShape = {
  position: shape({
    x: number, y: number, z: number
  }),
  quaternion: shape({
    _x: number, _y: number, _z: number, _w: number
  })
};



// WEBPACK FOOTER //
// ./src/lib/shapes.js